import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

const supported = typeof window !== 'undefined' && (window as any).Capacitor?.isNativePlatform?.();

export const hap = {
  selection: () => supported ? Haptics.selectionStart().catch(() => {}) : null,
  light: () => supported ? Haptics.impact({ style: ImpactStyle.Light }).catch(() => {}) : null,
  medium: () => supported ? Haptics.impact({ style: ImpactStyle.Medium }).catch(() => {}) : null,
  heavy: () => supported ? Haptics.impact({ style: ImpactStyle.Heavy }).catch(() => {}) : null,
  success: () => supported ? Haptics.notification({ type: NotificationType.Success }).catch(() => {}) : null,
  warning: () => supported ? Haptics.notification({ type: NotificationType.Warning }).catch(() => {}) : null,
};
